import styled from '@emotion/styled';
import { device, typography } from '@landsbankinn/ui';
import React from 'react';

interface IProps {
  title: string | null;
  copy: React.ReactNode;
  children: React.ReactNode;
}

const Host = styled.div``;

const Body = styled.div`
  padding-top: ${(props) => 8 * props.theme.baseline}px;

  @media ${device.tablet} {
    max-width: 910px;
    padding-right: 120px;
  }
`;

const Title = styled.h3`
  ${typography.h4}

  margin-bottom: 4px;
`;

const Copy = styled.p``;

const Child = styled.div``;

export const MediaItem = ({ title, copy, children }: IProps) => {
  return (
    <Host>
      <Child>{children}</Child>
      {(!!title || !!copy) && (
        <Body>
          {!!title && <Title>{title}</Title>}
          {!!copy && <Copy>{copy}</Copy>}
        </Body>
      )}
    </Host>
  );
};
